import React from 'react'
import './cssBoiler.css'
import './Section.css'
import ProjectsSection from "./ProjectsSection";
import ModernSkillsSection from "./ModernSkillsSection";
import ModernAboutSection from "./ModernAboutSection";
import HireMeSection from "./HireMeSection";

function Section() {
  return (
    <div className="whole-section">
      <ModernAboutSection />
      <div className="section-divider"></div>
      <ModernSkillsSection />
      <div className="section-divider"></div>
      <ProjectsSection />
      <div className="section-divider"></div>
      <HireMeSection />
    </div>
  );
}

export default Section